import { inject, Injector } from '@angular/core';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';
import {
	FiltersConfig,
	FilterTypeEnum,
} from '../../../../shared/models/filters-config';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../shared/tokens/searchable-strategy.token';
import { TagSearchStrategy } from '../../tags/config/tag-searchable-strategy';
import { VehicleSearchStrategy } from '../../vehicles/config/vehicle-searchable-strategy';
import { VEHICLE_INSURANCE_STATUSES } from '../translations/vehicle-insurances-select-items';
import { VehicleInsurancesService } from '../vehicle-insurances.service';

export function getVehicleInsuranceFilters(): FiltersConfig[] {
	const service = inject(VehicleInsurancesService);
	const injector = inject(Injector);
	return [
		{
			title: 'vehicle-insurances|filter|statuses',
			options: VEHICLE_INSURANCE_STATUSES,
			type: FilterTypeEnum.MULTI,
			selected$: service.vehicleInsurancesFilters.statuses$,
		},
		...(FEATURES.vehicles
			? [
					{
						title: 'vehicle-insurances|filter|vehicles',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.VEHICLES,
						selected$: service.vehicleInsurancesFilters.vehicles$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: VehicleSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
		...(FEATURES.tags
			? [
					{
						title: 'vehicle-insurances|filter|tags',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.TAGS,
						selected$: service.vehicleInsurancesFilters.tags$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: TagSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
	];
}
